import { getMasterData } from 'master-data'
import { type MasterData } from 'types/masterData'

import type { featureFlagKeys } from '../constants/featureFlags'
import { featureFlagServer } from '../featureFlagServer'
import type { FeatureFlag } from '../types'

export const featureFlag = <T extends FeatureFlag>(
	featureFlagId: featureFlagKeys
): T => {
	const masterData: Partial<MasterData> = getMasterData()

	return featureFlagServer({
		featureFlagId,
		masterData,
	}) as T
}
